import { PromptFunction } from '../../types';

/**
 * 创建自定义函数的工厂方法
 * @param name 函数名
 * @param description 函数描述
 * @param execute 执行函数
 * @param params 参数定义
 * @returns 自定义函数对象
 */

export const createCustomFunction = (
  name: string,
  description: string,
  execute: PromptFunction['execute'],
  params?: PromptFunction['params'],
): PromptFunction => ({
  name,
  description,
  params,
  execute,
});